module.exports = __webpack_public_path__ + "static/turtle-creek-house40-e481a7cd5d342b05741115a3323904fa.jpg";